/**
 * CenterChannelLogo component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled center channel logo.
 */
const CenterChannelLogo = styled.img<React.CSSProperties>`
  top: ${153 * Screen.widthRatio}px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: ${276 * Screen.widthRatio}px;
`;

export default withImage(CenterChannelLogo, true, '', '0.3');
